/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { makeVar } from '@apollo/client';
import { ExportState } from '../../service/gen/export';
import { DataExportModalProps } from '../../views/containers/DataExport/DataExportModal';

export const isEnvironmentPickerOpen = makeVar<boolean>(false);

export const dataExportModalProps = makeVar<DataExportModalProps>({ isOpen: false });

export const dataExportButtonStatus = makeVar<ExportState>(null);

export const filterSelection = makeVar<string>('');

export const keywordSearchSelection = makeVar<string>('');
